var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section" }, [
    _c(
      "div",
      { staticClass: "section filters" },
      [
        _c("multiselect", {
          attrs: {
            options: _vm.customers,
            multiple: false,
            "close-on-select": true,
            placeholder: "Pick customer...",
            label: "name",
            "track-by": "name",
          },
          model: {
            value: _vm.selectedCustomer,
            callback: function ($$v) {
              _vm.selectedCustomer = $$v
            },
            expression: "selectedCustomer",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticStyle: { padding: "2px" } },
      [
        _c("ag-grid-vue", {
          staticClass: "ag-theme-balham",
          staticStyle: { width: "100%", height: "1000px" },
          attrs: {
            "grid-options": _vm.gridOptions,
            pagination: true,
            "pagination-auto-page-size": true,
            "animate-rows": true,
            "multi-sort-key": "ctrl",
            "row-selection": "multiple",
            "get-child-count": _vm.getChildCount,
            modules: _vm.modules,
          },
          on: { "grid-ready": _vm.gridReady },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }